import AsyncSelect from "./AsyncSelect"
import { Controller } from "react-hook-form";

const AsyncSelectControlled = ({
  control,
  name,
  rules,
  label,
  defaultLabel,
  options = [],
  hasMore,
  fetchNext,
  isLoading,
  isMultiple,
  placeholder,
}) => {
  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({ field: { value, onChange }, fieldState: { error } }) => {
        return (
          <div>
            <AsyncSelect
              label={label}
              options={options || []}
              value={value || {}}
              defaultLabel={defaultLabel}
              onChange={(val) => {
                onChange(val);
              }}
              hasMore={hasMore}
              fetchNext={fetchNext}
              isLoading={isLoading}
              placeholder={placeholder}
              isMultiple={isMultiple}
            />
            {error && <p className="mt-[0.5rem] text-red-500">{error.message}</p>}
          </div>
        );
      }}
    />
  );
};

export default AsyncSelectControlled;
